import Vue from "vue";
import axios from "axios";
import PortalVue from "portal-vue";
let BottomSheet = require("./../components/Shared/BottomSheet.vue").default;

module.exports = {
	initialize: function(callback) {
		let defaultCountryCode = process.env.COUNTRY_CODE || null;
		let storedCountryCode = localStorage.hasOwnProperty("countryCode")
			? JSON.parse(localStorage.countryCode)
			: defaultCountryCode;

		let countryConfigs = {};
		(async () => {
			// await axios.get("../config.json").then((config) => {
			// 	countryConfigs = config.data;
			// });
			countryConfigs = require("../../config.json");

			if (storedCountryCode) {
				let storedCountryConfigs =
					countryConfigs[storedCountryCode.toUpperCase()];

				initializeCountryConfigs(storedCountryConfigs);
				callback(storedCountryConfigs);
			} else {
				const countryCodes = ["KE", "GH", "TZ", "NG", "ET"];
				var axiosConfig = {};
				axios
					.get("https://ip.betika.com", axiosConfig)
					.then((response) => {
						let countryCode = response.data.countryCode.toUpperCase();

						// localStorage.countryCode = JSON.stringify(countryCode);

						const countries = [
							{
								code: "ET",
								name: "Ethiopia",
								imageSrc:
									"https://storage.googleapis.com/betika-staging-cdn/country-flags/svg-src/ethiopia.svg",
							},
							{
								code: "KE",
								name: "Kenya",
								imageSrc:
									"https://storage.googleapis.com/betika-staging-cdn/country-flags/svg-src/kenya.svg",
							},
							{
								code: "GH",
								name: "Ghana",
								imageSrc:
									"https://storage.googleapis.com/betika-staging-cdn/country-flags/svg-src/ghana.svg",
							},
							{
								code: "NG",
								name: "Nigeria",
								imageSrc:
									"https://storage.googleapis.com/betika-staging-cdn/country-flags/svg-src/nigeria.svg",
							},
						];

						const initialState = {
							confirmed: false,
							countryListOpen: false,
							selectedCountry: response.data.country,
							country: response.data.country,
							selectedCountryCode: countryCode,
							countries: countries,
							canShowBottomSheet: true,
						};

						const CountryList = Vue.extend({
							template: "#country-list",
							data() {
								return {
									countries: countries,
								};
							},
							methods: {
								selectCountry(country) {
									let vm = this;
									vm.$emit("selectCountry", country);
								},
							},
						});

						// Vue.component("bottom-sheet", PullUpBottom);
						Vue.use(PortalVue);

						const CountrySelector = Vue.extend({
							template: "#country-root",
							components: { CountryList, BottomSheet },
							data: () => {
								return initialState;
							},
							methods: {
								confirmCountry() {
									let vm = this;
									let countryConfirmEvent = new CustomEvent(
										"countryConfirmed",
										{
											detail: vm.selectedCountryCode,
										}
									);
									this.confirmed = true;
									window.dispatchEvent(countryConfirmEvent);
									vm.closeBottomSheet();
								},
								updateSelectedCountry(country) {
									let vm = this;
									vm.selectedCountryCode = country.code;
									vm.country = country.name;
									vm.countryListOpen = false;
								},
								closeBottomSheet() {
									let vm = this;
									vm.$refs.bottomSheet.setState("close");
									vm.$nextTick(() => {
										vm.canShowBottomSheet = false;
									});
								},
								showBottomSheet() {
									let vm = this;
									vm.canShowBottomSheet = true;
									vm.$nextTick(() => {
										vm.$refs.bottomSheet.setState("open");
									});
								},
							},
						});
						var appID = document.getElementById("app");
						appID.style.display = "none";

						const countryApp = new Vue({
							el: "#country-confirmer",
							components: { CountrySelector },
							template: `<country-selector />`,
						});

						window.addEventListener("countryConfirmed", function eventHandler(
							e
						) {
							let confirmedCountryCode = e.detail;
							if (confirmedCountryCode == "ET") {
								return (window.location = "https://www.betika.com/et/");
							}
							let foundCountryConfigs = countryCodes.includes(
								confirmedCountryCode
							)
								? countryConfigs[confirmedCountryCode]
								: countryConfigs["KE"];

							let countryCodeFound = countryCodes.includes(confirmedCountryCode)
								? true
								: false;

							confirmedCountryCode = countryCodes.includes(confirmedCountryCode)
								? confirmedCountryCode
								: "KE";
							localStorage.countryCode = JSON.stringify(confirmedCountryCode);
							initializeCountryConfigs(foundCountryConfigs);
							appID.style.display = "block";
							var countryAppID = document.getElementsByClassName(
								"country-choice"
							)[0];
							countryAppID.style.display = "none";
							callback(foundCountryConfigs);
						});
					})
					.catch((data, status) => {
						let keCountryCode = "KE";
						let foundCountryConfigs = countryConfigs["KE"];
						localStorage.countryCode = JSON.stringify(keCountryCode);
						console.log(
							"[Country Code finder] Found countries in Catch",
							countryConfigs
						);
						initializeCountryConfigs(foundCountryConfigs);
						callback(foundCountryConfigs);
					});
			}
		})();
	},
};

// const camelToSnakeCase = (str) =>
// 	str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

let initializeCountryConfigs = (config) => {
	// Object.keys(config).forEach((configItem) => {
	// 	console.log(camelToSnakeCase(configItem).toUpperCase(), config[configItem]);
	// 	window[camelToSnakeCase(configItem).toUpperCase()] = config[configItem];
	// });
	window.BASE_URL = config.baseUrl;
	window.RECOMMEDATIONS_API_URL = config.recommendationsAPIUrl;
	window.BASE_V2_URL = config.baseV2Url;
	window.LIVE_URL = config.liveUrl;
	window.VIRTUALS_URL = config.virtualsUrl;
	window.API_KEY = config.apiKey;
	window.NEKTAN_API_URL = config.nektanAPIURL;
	window.NOTIFICATIONS_API_URL = config.notificationsAPIUrl;
	window.NOTIFICATIONS_SOCKET_URL = config.notificationsSocketUrl;
	window.GOLDEN_RACE_LOADER_URL = config.goldenRaceLoaderUrl;
	window.LIVE_SCORE_URL = config.liveScoreUrl;
	window.GOLDEN_RACE_API_BASE_URL = config.goldenRaceAPIBaseUrl;
	window.GOLDEN_RACE_HWID = config.goldenRaceHwID;
	window.GOLDEN_RACE_PROFILE = config.goldenRaceProfile;
	window.LEGAL_DATA = config.legalData;
	window.MOBILE_URL = config.mobileUrl;
	window.DESKTOP_URL = config.desktopUrl;
	window.CAMPAIGN_URL = config.campaignUrl;
	window.FREE_BETS_API_URL = config.freeBetsAPIUrl;
	window.PROMOS_API_URL = config.promosAPIUrl;
	window.CDN_URL = config.cdnUrl;
	window.USERINFO_URL = config.userInfoUrl;
	window.MOBILE_REGEX = config.mobileRegex;
	window.MINIMUM_BET_AMOUNT = config.minimumBetAmount;
	window.MAXIMUM_BET_AMOUNT = config.maximumBetAmount;
	window.MAXIMUM_POSSIBLE_WIN = config.maximumPossibleWin;
	window.MOBILE_SAMPLE = config.mobileSample;
	window.MOBILE_PREFIX = config.mobilePrefix;
	window.CURRENCY = config.currency;
	window.LOCALE = config.locale;
	window.WHT_TAX = config.whtTax;
	window.WEBSITE_TITLE = config.websiteTitle;
	window.WEBSITE_DESCRIPTION = config.websiteDescription;
	window.APP_NAME = config.appName;
	window.APP_SRC = config.appSrc;
	window.GA_ID = config.gaID;
	window.GTM_ID = config.gtmID;
	window.USSD_VERIFICATION_CODE_NUMBER = config.ussdVerificationCodeNumber;
	window.SHIKISHA_PRODUCT_NAME = config.shikishaProductName;
	window.SABABISHA_PRODUCT_NAME = config.sababishaProductName;
	window.TIMEZONE = config.timezone;

	// window.BOOSTED_BETS_API_URL = config.boostedBetsAPIUrl;
	window.supportsWebSockets = typeof window.WebSocket == "function";
};
